module.exports = __webpack_public_path__ + "static/media/sports_26.347adfcc.jpg";